import React, { useEffect, useState } from "react";
import HeaderAction from "../components/HeaderAction";
import styled from "styled-components";
import Tab from "../components/Tab";
import ListProduct from "../components/ListProduct";
import {
  ID_TAB_EVENT_THINGYAN_2025,
  ID_TAB_TAKE_PRIZE,
} from "../../../../helper/const";
import BgPrize from "../../../../assets/images/Event-2025/bg-prize-tiny.png";
import FooterDetail from "../components/FooterDetail";
import { dataDetail, ID_PRIZE } from "../components/DefineData";
import iconBg1 from "../../../../assets/images/Event-2025/bg-icon-01.png";
import iconBg2 from "../../../../assets/images/Event-2025/bg-icon-2.png";
import { useNavigate } from "react-router";
import PATH from "../../../../config/PATH";
import WinnerComponent from "../components/Winner";
import { getDataApi } from "../../../../config/service";
import API_PATH from "../../../../config/API_PATH";
import { curStateAccount } from "../../../../Redux/selector";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function PieceCollection() {
  const {t} = useTranslation()
  const selectorAccount = useSelector(curStateAccount);
  const navigate = useNavigate();
  const [itemProductActive, setItemProductActive] = useState(ID_PRIZE.prize_1);

  const [dataAwardActive, setDataAwardActive] = useState([]);

  const handleGetDataCollected = async () => {
    const dataApi = await getDataApi(API_PATH.thingyanPieceCollected, {
      award_id: itemProductActive,
    });
    const dataAwardActive = dataApi?.data;
    const newData = dataDetail.filter((item) => item.id === itemProductActive);
    const dataConvert = newData.map((item = {}) => {
      const itemFormat = item.srcDetailCollection.map((detail) => {
        let newItem = {};
        dataAwardActive.forEach((award = {}) => {
          if (award.name == detail.name) {
            newItem = {
              ...award,
              ...detail,
            };
          }
        });
        return {
          ...detail,
          ...newItem,
        };
      });

      return {
        ...item,
        srcDetailCollection: itemFormat,
      };
    });
    setDataAwardActive(dataConvert[0] || {});
  };

  useEffect(() => {
    if (selectorAccount.userInfo) {
      handleGetDataCollected();
    } else{
      const newData = dataDetail.find((item) => item.id === itemProductActive)
      setDataAwardActive(newData)
    }
  }, [itemProductActive, selectorAccount.userInfo]);

  return (
    <Container className="container-thingyan">
      <div className="thingyan-home-header">
        <img src={iconBg1} alt="" className="icon-bg-web1" />
        <img src={iconBg2} alt="" className="icon-bg-web2" />
        <div className="header-take-prize">
          <HeaderAction />
        </div>
        <Tab idActive={ID_TAB_TAKE_PRIZE.pieceCollection} />
        <ListProduct
          setItemProductActive={setItemProductActive}
          itemProductActive={itemProductActive}
        />
        <WinnerComponent />
        <div className="content-prize">
          {dataAwardActive.srcDetailCollection ? (
            dataAwardActive.srcDetailCollection.map((item, index) => (
              <div
                className="content-prize_item"
                key={`${dataAwardActive.title}_${index}`}
              >
                <img src={BgPrize} alt="" className="bg-prize" />
                <div className="content-prize_total">x{item?.num || 0}</div>
                <div className="img-icon-prize">
                  <img src={item.src} alt="" />
                </div>
                <div className="content-detail shrikhand-regular content-container-prize1">
                  Piece {item.name}
                </div>
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
        <div className="footer-detail-piece">
          <FooterDetail
            filterData={dataAwardActive}
            contentBtn={t("event_thingyan.piece_collection.earn_more_piece")}
            isActiveButton
            action={() =>
              navigate(
                `${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.home}`
              )
            }
          />
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  .icon-winner__collect {
    z-index: 22;
    position: absolute;
    left: 45px;
  }

  .content-detail {
    position: absolute;
    bottom: 20px;
    min-width: 130px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
    background: linear-gradient(to bottom, #ffffff 25%, #a5deff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /* font-weight: bold; */
    filter: drop-shadow(2px 0 0 #176ee5) drop-shadow(-2px 0 0 #176ee5)
      drop-shadow(0 4px 0 #176ee5) drop-shadow(0 -2px 0 #176ee5) !important;
  }

  .footer-detail-piece {
    position: relative;
    z-index: 20;
  }

  .content-prize {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin: 0 10%;
    gap: 16px;
    position: relative;
    z-index: 1;
    /* pointer-events: none; */

    &_item {
      text-align: center;
      position: relative;
      width: max-content;
      margin: 0 auto;
    }

    &_total {
      position: absolute;
      top: 4px;
      right: 4px;
      color: white;
      font-size: 18px;
      width: 63px;
      height: 31px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .header-take-prize {
    padding-top: 18px;
    margin-bottom: 30px;
  }

  .thingyan-home-header {
    overflow-y: hidden;
  }

  .img-icon-prize {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (min-width: 1400px) {
    .header-take-prize {
      padding-top: 25px;
    }

    .content-prize {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 25px;
      padding-bottom: 150px;
      padding-top: 50px;
      position: relative;
      z-index: 9;
    }
  }

  @media (max-width: 1400px) {
    .content-prize {
      max-height: 700px;
      overflow-y: auto;
      padding-bottom: 150px;
      &::-webkit-scrollbar {
        width: 0px;
      }
    }
  }

  @media (max-width: 768px) {
    .content-prize_item {
      width: 100%;
    }

    .icon-winner__collect {
      z-index: 2;
      position: absolute;
      left: 0;
      width: 60px;
    }

    .thingyan-home-header {
      position: relative;
    }

    .content-prize {
      margin: 0 6%;
      /* max-height: 880px; */
      overflow: scroll;
      padding-bottom: 210px;
      &::-webkit-scrollbar {
        width: 0px;
      }
    }

    .footer-detail-piece {
      position: absolute;
      bottom: 0;
      width: 100%;
      z-index: 2;
    }
  }

  @media (max-width: 576px) {
    .header-take-prize {
      padding-top: 10px;
    }

    .content-prize {
      margin: 0 12px;
      gap: 12px;
    }

    .header-take-prize {
      margin-bottom: 20px;
    }

    .content-detail {
      font-size: 20px;
      filter: drop-shadow(1px 0 0 #176ee5) drop-shadow(-1px 0 0 #176ee5)
        drop-shadow(0 3px 0 #176ee5) drop-shadow(0 -1px 0 #176ee5) !important;
      bottom: 10px;
    }
  }

  @media (max-width: 440px) {
    .content-prize_total {
      font-size: 12px;
      width: auto;
      height: auto;
      right: 14px;
      top: 8px;
    }

    .bg-prize {
      height: 192px;
    }
  }
`;
